module.exports = __webpack_public_path__ + "static/media/whyMenaraTravels.f12d48ab.jpg";